<template>
  <div class="news-detail">
    <!-- 返回按钮 -->
    <div class="back-button-container">
      <button class="back-btn" @click="goBack">
        <span class="arrow">←</span>
        <span>返回</span>
      </button>
    </div>

    <!-- 新闻内容 -->
    <div class="news-detail-content" v-if="currentNews">
      <!-- 标题 -->
      <h1 class="news-detail-title">{{ currentNews.title }}</h1>
      
      <!-- 日期与地点 -->
      <div class="news-detail-date">
        <span>{{ currentNews.date }}</span>
        <span v-if="currentNews.location"> · {{ currentNews.location }}</span>
      </div>
      
      <!-- 内容列表 -->
      <div class="content-list">
        <div v-for="(item, index) in contentList" :key="index" class="content-item">
          <!-- 标题 -->
          <div v-if="item.type === 'title'">
            <h1  class="content-num">{{ item.num }}</h1>
            <div  class="content-title">{{ item.content }}</div>
          </div>
          
          <!-- 文字段落 -->
          <p v-if="item.type === 'text'" class="content-text">{{ item.content }}</p>
          
          <!-- 图片 -->
          <div v-if="item.type === 'image'" class="content-image">
            <img :src="item.content" :alt="item.alt || '新闻图片'" />
            <div>{{ item.text }}</div>
          </div>
          
          <!-- 视频 -->
          <div v-if="item.type === 'video'" class="content-video">
            <video :src="item.content" controls></video>
          </div>
        </div>
      </div>
      
      <!-- 分页按钮 -->
      <div class="pagination">
        <div 
          class="pager-link prev"
          :class="{ disabled: !hasPrev }"
          @click="hasPrev && goToPrev()"
        >
          <div class="pager-label">
            <i class="el-icon-arrow-left"></i>
            <span>上一篇</span>
          </div>
          <div class="pager-title" v-if="prevNews">{{ prevNews.title }}</div>
          <div class="pager-title empty" v-else>没有了</div>
        </div>
        <div 
          class="pager-link next"
          :class="{ disabled: !hasNext }"
          @click="hasNext && goToNext()"
        >
          <div class="pager-label">
            <span>下一篇</span>
            <i class="el-icon-arrow-right"></i>
          </div>
          <div class="pager-title" v-if="nextNews">{{ nextNews.title }}</div>
          <div class="pager-title empty" v-else>没有了</div>
        </div>
      </div>
    </div>
    
    <!-- 无数据提示 -->
    <div v-else class="no-data">
      <p>暂无数据</p>
    </div>
  </div>
</template>

<script>
// 新闻数据可以在这里导入，或者通过 Vuex/事件总线传递
const allNewsList = [
    {
      id: 20251031,
      title: '华视闪宝屏形机器人亮相武汉建博会，AI数字人解决方案引关注',
      description: '10月23日，华视集团与随县人民政府成功举行数字经济产业项目签约仪式。随县县委书记陈良、华视集团董事长陈继承等双方领导出席活动并见证签约',
      date: '2025年10月31日 21:30',
      location: '湖北',
      img: require('@/assets/image/news/10-31-1.jpg'),
      content: [
        { type: 'text', content: '10月31日，2025国际（武汉）智能建造产业博览会在中国光谷科技会展中心 隆重开幕。博览会由中建三局、华为、清华大学等24家单位共同主办，重点关注行业当前面临的痛点与发展趋势。' },
        { type: 'image', content: require('@/assets/image/news/10-31-1.jpg'), alt: '1' },
        { type: 'text', content: '展会期间，华视闪宝屏形机器人现身会场，集中展示了其在建筑展示与智能家居领域的创新应用，现场吸引众多行业人士驻足交流，观展反响热烈。' },
        { type: 'image', content: require('@/assets/image/news/10-31-2.jpg'), alt: '1' },
        { type: 'image', content: require('@/assets/image/news/10-31-3.jpg'), alt: '1' },
        { type: 'image', content: require('@/assets/image/news/10-31-4.jpg'), alt: '1' },
        { type: 'image', content: require('@/assets/image/news/10-31-5.jpg'), alt: '1' },
        { type: 'image', content: require('@/assets/image/news/10-31-6.jpg'), alt: '1', text: '展会现场' },
        { type: 'text', content: '在展区现场，华视闪宝屏形机器人自如穿梭于人群之中，凭借其工业级透明OLED显示屏和智能感应系统，实现精准自主导航与动态避障。不同于传统应答设备，它能够主动感知观众需求，提供迎宾接待、智能导引、多语种实时翻译及问答服务。其流畅的交互体验和科技感受，引来不少观众驻足体验和拍照。' },
        { type: 'image', content: require('@/assets/image/news/10-31-7.jpg'), alt: '8', },
        { type: 'text', content: '现场建筑行业专家体验后表示，数字人讲解不仅形象生动、交互流畅，更依托背后强大的专业数据库，能够提供全面而权威的内容输出，有效辅助观众理解复杂项目细节，整体体验直观自然。' },
        { type: 'text', content: '此外，华视闪宝的AIGC视频生成系统可实现建筑设计模型的快速三维可视化转换，用户仅需输入关键参数，系统即可自动生成展示建筑细节、材质及环境效果的视频内容。该技术特别适用于大型项目前期方案展示，帮助客户在施工前直观感知建成效果。' },
        { type: 'image', content: require('@/assets/image/news/10-31-8.jpg'), alt: '9', },
        { type: 'text', content: '华视闪宝产品总监表示，华视闪宝AI数字人解决方案凭借高度的集成性与稳定的交互表现，已在多个示范项目中获得积极反馈，显示出较强的行业竞争力与落地潜力。目前公司已与多家房地产企业达成合作，计划在高端住宅项目中部署该数字人系统。' },
        { type: 'image', content: require('@/assets/image/news/10-31-9.jpg'), alt: '9', },
        { type: 'text', content: '建博会期间，华视闪宝与数十家建筑科技企业展开深入对接，并达成多项合作意向，涵盖数字人IP定制、AIGC视频内容生产、智能导览系统建设、屏形机器人等多个前沿领域，充分展现了华视闪宝数字人技术在建筑领域场景中的应用价值。未来，双方将围绕建筑展示和家居等具体场景，共同开发定制化数字人解决方案，推动AI技术与建筑行业的深度融合。' },
        { type: 'image', content: require('@/assets/image/news/10-31-10.jpg'), alt: '9', },
        { type: 'text', content: '据华视闪宝负责人介绍，展会开始仅半日，已有超过30家建筑设计院及开发商表达明确合作意向。此次密集对接取得的丰硕成果，为公司AI数字人技术在建筑领域的规模化应用奠定了坚实基础。华视闪宝将持续为合作伙伴在提升效率、优化成本与创新服务方面创造切实价值。' },
        { type: 'image', content: require('@/assets/image/news/10-31-11.jpg'), alt: '9', },
        { type: 'text', content: '随着建筑行业数字化进程加速，华视闪宝通过AI数字人技术，为设计展示、家居交互及项目运维等环节提供创新解决方案，本次博览会已成为其技术落地与产业合作的重要助推器。' },
      ],
    },
    {
    id: 20251024,
    title: '华视AI屏形机器人入驻武汉阿里中心，助力滨江数创走廊政务智能升级',
    description: '10月22日，武汉阿里中心正式开园。活动现场，华视集团自主研发的屏形机器人凭借领先的AI交互能力与智能化一站式服务，为滨江数创走廊政务服务站注入数字新活力，成为全场关注的亮点之一。阿里巴巴集团公共事务总裁闻佳、武昌区委书记余松、区长范礼奎等领导嘉宾现场与华视AI屏形机器人互动交流。',
    date: '2025年10月24日 18:29',
    location: '湖北',
    img: require('@/assets/image/news/details-2025-10-24-1.jpg'),
    content: [
      { type: 'image', content: require('@/assets/image/news/details-2025-10-24-1.jpg'), alt: '签约仪式现场' },
      { type: 'text', content: '10月22日，武汉阿里中心正式开园。活动现场，华视集团自主研发的屏形机器人凭借领先的AI交互能力与智能化一站式服务，为滨江数创走廊政务服务站注入数字新活力，成为全场关注的亮点之一。阿里巴巴集团公共事务总裁闻佳、武昌区委书记余松、区长范礼奎等领导嘉宾现场与华视AI屏形机器人互动交流。' },
      { type: 'image', content: require('@/assets/image/news/details-2025-10-24-2.jpg'), alt: '签约仪式现场' },
      { type: 'text', content: '此次项目的成功落地，不仅体现了公司以创新驱动数字经济发展的技术实力，也彰显了其在AI应用领域的核心价值。通过与阿里巴巴等生态伙伴的紧密协作，华视进一步强化了产业协同效应，巩固了在AI数字人领域的前沿地位，为拓展更丰富的数字人应用场景奠定了坚实基础。' },
    ],
  },
  {
    id: 20251023,
    title: '随县人民政府与华视集团签署数字经济产业项目合作协议',
    description: '10月23日，华视集团与随县人民政府成功举行数字经济产业项目签约仪式。随县县委书记陈良、华视集团董事长陈继承等双方领导出席活动并见证签约',
    date: '2025-10-23',
    location: '湖北',
    img: require('@/assets/image/news/10-23-2.jpg'),
    content: [
      { type: 'text', content: '10月23日，华视集团与随县人民政府成功举行数字经济产业项目签约仪式。随县县委书记陈良、华视集团董事长陈继承等双方领导出席活动并见证签约。' },
      { type: 'image', content: require('@/assets/image/news/10-23-2.jpg'), alt: '签约仪式现场' },
      { type: 'text', content: '此次签约标志着双方在数字经济发展领域的深度合作，将共同推进随县数字化转型和产业升级。' }
    ]
  },
  {
    id: 20251017,
    title: '武汉市司法局局长、民建武汉市委会主委穆书芹考察调研华视集团',
    description: '10月17日，武汉市司法局局长、民建武汉市委会主委穆书芹率队莅临华视集团东湖总部，开展考察调研工作。',
    date: '2025-10-17',
    location: '湖北',
    img: require('@/assets/image/news/10-17.jpg'),
    content: [
      { type: 'text', content: '10月17日，武汉市司法局局长、民建武汉市委会主委穆书芹率队莅临华视集团东湖总部，开展考察调研工作，实地了解企业在人工智能领域的发展现状。' },
      { type: 'image', content: require('@/assets/image/news/10-17-1.jpg'), alt: '考察现场' },
      { type: 'text', content: '穆书芹局长一行先后参观了公司AI数字创意展厅与华中融媒体生态产业园，详细了解了东湖品牌研究院运营管理、AI数字人技术研发、屏形机器人场景应用等方面的创新实践。考察过程中，穆局长近距离体验了华视闪宝数字人在多场景下的应用表现，对企业在AI技术开发领域取得的显著成效给予了充分肯定和高度评价。' },
      { type: 'text', content: '座谈会上，集团AI事业部负责人系统汇报了华视闪宝AI数字人在智能问答、多模态交互、场景化服务等方面的核心优势，同时就AI数字人在司法场景的创新应用进行了探索和展望。' },
      { type: 'text', content: '穆书芹局长指出，当前司法行政系统正积极推进数字化转型，人工智能技术的创新应用将为公共法律服务体系建设注入新动能。她表示，华视集团自主研发的系列AI产品在普法宣传、法律咨询、调解辅助等司法场景中具有重要的应用空间，能一站式提供更加智能化、便捷化的法律服务体验，大家要以此为契机，加强对接合作，共同探索AI技术与司法业务深度融合的创新路径。'},
      { type: 'image', content: require('@/assets/image/news/10-17.jpg'), alt: '考察现场' },
      { type: 'text', content: '交流环节，大家还围绕如何利用AI数字人技术提升司法服务效率、优化法治宣传模式、赋能智慧司法建设等议题展开了深入交流与广泛探讨。' },
      { type: 'text', content: '民建市委会调研室主任吴芳，武汉市司法局行政执法协调监督处处长、一级调研员张胜，办公室主任马云新，科技信息处处长李峥，立法二处处长刘远雄，公共法律服务管理处处长杨博，律师工作处处长樊静等参加活动。' },
    ]
  },
  {
    id: 20251011,
    title: '湖北公路客运集团到访华视集团考察交流，共商数字技术赋能智慧交通',
    description: '10月10日，湖北公路客运集团股份有限公司党委书记、董事长李青松率高管团队莅临华视集团，围绕AI数字人技术在智慧交通领域的创新应用开展实地考察与座谈交流。湖北公路客运集团副总经理钱浪、方松、库俊杰共同参与本次考察。',
    date: '2025-10-11',
    location: '湖北',
    img: require('@/assets/image/news/10-11.jpg'),
    content: [
      { type: 'text', content: '10月10日，湖北公路客运集团股份有限公司党委书记、董事长李青松率高管团队莅临华视集团，围绕AI数字人技术在智慧交通领域的创新应用开展实地考察与座谈交流。湖北公路客运集团副总经理钱浪、方松、库俊杰共同参与本次考察。' },
      { type: 'image', content: require('@/assets/image/news/10-11-1.jpg'), alt: '签约仪式现场' },
      { type: 'text', content: '调研中，李青松董事长一行先后参观了公司AI数字创意展厅、华中融媒体生态产业园和东湖文化长廊，详细了解了集团在AI数字人技术研发、智能融媒体平台构建等方面的创新成果，对华视在数字化领域的创新实践给予高度评价。' },
      { type: 'text', content: '座谈会上，集团AI项目团队向考察团系统讲解了华视闪宝AI数字人产品的核心功能与技术优势，现场介绍了AI数字人在智能客服、智慧政务、文旅推介等多类场景的实际应用效果。湖北公路客运集团方面对数字人产品表现出浓厚兴趣，双方围绕其在提升客运服务体验、优化站务管理、推动智慧交通发展等议题展开了积极讨论和深入交流，并初步达成合作意向。' },
      { type: 'image', content: require('@/assets/image/news/10-11-2.jpg'), alt: '签约仪式现场' },
      { type: 'text', content: '李青松董事长指出，湖北公路客运集团正积极推进数字化转型与智能化升级，华视的数字人技术具有前瞻性和实用价值，对集团业务智慧化升级具有借鉴意义，未来合作空间广阔。他表示，希望借助华视的技术支持，共同打造更具科技感与人性化的出行服务体验，助力客运业务创新升级。' },
      { type: 'text', content: '湖北公路客运集团旗下旅驰投资、城市运营、众行智慧、楚驰实业等主要分子公司相关负责人陪同考察。' },
    ]
  },
  {
    id: 20251019,
    title: '2025中国文旅博览会：华视闪宝首秀引关注，赋能文旅产业创新升级',
    description: '9月12日至14日，2025中国文化旅游产业博览会在武汉国际博览中心成功举办。华视闪宝数字人系列产品以创新的前沿科技与丰富的应用场景成为展会焦点，全面展示数字人技术在文旅产业的最新成果，获得了业界广泛认可。',
    date: '2025-9-19',
    location: '湖北',
    img: require('@/assets/image/news/9-19.jpg'),
    content: [
      { type: 'text', content: '9月12日至14日，2025中国文化旅游产业博览会在武汉国际博览中心成功举办。华视闪宝数字人系列产品以创新的前沿科技与丰富的应用场景成为展会焦点，全面展示数字人技术在文旅产业的最新成果，获得了业界广泛认可。' },
      {type: 'title', num: '01', content:'数字科技惊艳亮相，引发现场体验热潮'},
      { type: 'text', content: '活动中，华视闪宝展区凭借创新的数字人技术和丰富的场景化应用演示，成为现场最具人气的展区之一。超写实数字人形象生成、多语种实时交互、AIGC视频快速生成等演示环节引发持续关注，现场设置的多个互动体验区排起长队。' },
      { type: 'image', content: require('@/assets/image/news/9-19-1.jpg'), alt: '1' },
      { type: 'title', num: '02', content:'创新产品组合落地武昌、新洲等多个展馆打造智慧文旅示范窗口' },
      { type: 'text', content: '在武昌区和新洲区特色展馆中，华视闪宝创新推出的AI随身秘书＋屏形机器人的产品组合精彩亮相，助力其展位成为本届文博会智慧文旅的示范性场景。两款产品协同发力，凭借“视觉交互＋语音智能”的创新组合吸引了大量观众驻足互动，不仅显著提升了展位的客流量，也营造出浓厚的科技互动氛围，成为现场人气焦点。' },
      { type: 'image', content: require('@/assets/image/news/9-19-2.jpg'), alt: '1' },
      { type: 'image', content: require('@/assets/image/news/9-19-3.jpg'), alt: '1', text: '华视闪宝数字人广泛应用于文旅博览会各大展区' },
      { type: 'text', content: '据悉，武昌展位对华视闪宝两款产品的应用效果十分满意，目前双方已达成共识，计划于昙华林历史街区和更多文旅场景中部署该解决方案，通过数字人导览讲解、AI语音导购等功能，打造武昌区智慧文旅新地标。' },
      { type: 'title', num: '03', content:'数字创新引关注，多级领导点赞文旅创新成果' },
      { type: 'text', content: '展会期间，华视闪宝产品受到了多位领导的关注与肯定。武汉市委副书记、市长盛阅春亲临现场，沉浸式体验了数字人交互系统和屏形机器人等核心产品，对集团运用人工智能科技推动文旅融合的创新实践成果给予了充分肯定。' },
      { type: 'image', content: require('@/assets/image/news/9-19-4.jpg'), alt: '1', text: '武汉市委副书记、市长盛阅春现场与华视闪宝屏形机器人互动' },
      { type: 'text', content: '湖北省委宣传部常务副部长刘海军、省文旅厅党组书记、厅长，省文物局局长克克、武汉市委常委、宣传部部长吴朝安等领导也先后莅临展位视察指导，详细了解了数字人技术的研发进程与应用前景，并对华视闪宝在AI赋能文旅创新方面取得的成果予以高度认可。' },
      { type: 'image', content: require('@/assets/image/news/9-19-5.jpg'), alt: '1', text: '湖北省委宣传部常务副部长刘海军考察华视闪宝展厅' },
      { type: 'image', content: require('@/assets/image/news/9-19-6.jpg'), alt: '1', text: '湖北省文化和旅游厅党组书记、厅长，省文物局局长克克考察华视闪宝展厅' },
      { type: 'image', content: require('@/assets/image/news/9-19-7.jpg'), alt: '1', text: '武汉市委常委、宣传部部长吴朝安考察华视闪宝展厅' },
      { type: 'text', content: '各级领导的到访与勉励，充分体现了省市政府对文旅产业数字化、智能化转型的高度重视，也为华视闪宝未来的发展指明了方向。' },
      { type: 'title', num: '04', content:'行业影响广泛，战略合作开启新篇章' },
      { type: 'text', content: '展会上，华视闪宝与全国四十余家单位达成战略合作，涵盖多地文旅主管部门、知名文化机构与领先科技企业，包括山西、宁夏、西安、武汉等多地文旅单位，故宫博物院、湖北省博物馆等重要文化场馆，以及中国电信、腾讯等科技伙伴，共同构建智慧文旅新生态。' },
      { type: 'image', content: require('@/assets/image/news/9-19-8.jpg'), alt: '1' },
      { type: 'image', content: require('@/assets/image/news/9-19-9.jpg'), alt: '1', text: '华视闪宝多省市合作，赋能文旅新体验' },
      { type: 'text', content: '此次大规模合作标志着华视闪宝的数字化解决方案获得了行业广泛认可，进一步巩固了市场领先地位，公司将持续为合作单位提供多形态AI解决方案，助力提升公众服务体验，丰富文旅互动形式。' },
      { type: 'title', num: '05', content:'媒体广泛报道，科技创新成果好评如潮' },
      { type: 'text', content: '华视闪宝数字人在博览会上的精彩亮相引发行业广泛关注，包括人民网、光明日报、新华网、央广网、中新网、湖北日报、长江日报等在内的20余家央级、省级及市级媒体相继进行报道，成为本届博览会科技赋能文旅的代表案例。媒体报道聚焦华视闪宝数字人在文旅场景的创新应用，生动呈现AI科技为传统文旅产业带来的焕新动能。' },
      { type: 'image', content: require('@/assets/image/news/9-19-10.jpg'), alt: '1' },
      { type: 'title', num: '06', content:'深化技术赋能，共建智慧文旅新生态' },
      { type: 'text', content: '本次展会，华视闪宝收获了大量宝贵的行业反馈和市场洞察信息，后续将继续深化数字人技术在文旅场景的创新应用，重点提升数字人的文化理解力、场景适应性和服务亲和力，持续完善产品体系，深化场景应用，为文旅产业提供更加智能、便捷、高效的数字化解决方案。' },
      { type: 'image', content: require('@/assets/image/news/9-19-11.jpg'), alt: '1' },
      { type: 'text', content: '未来，公司将重点推进与四十余家战略伙伴的深度合作，加速已签约项目的落地实施。同时深化AIGC、实时渲染、情感计算等核心技术在文化传承、智慧导览、虚拟体验等场景的应用创新，为线下智慧服务提供更完善的解决方案。' },
   ]
  },
  {
    id: 20250917,
    title: '华视闪宝与四十余家单位达成战略合作，共拓智慧文旅新格局',
    description: '在2025中国文化旅游产业博览会上，华视集团与四十余家单位正式达成华视闪宝战略合作，各方将共同推进AI数字人项目的落地应用。此次大规模合作标志着华视闪宝在文旅数字化解决方案方面获得了行业广泛认可，进一步巩固了市场领先地位。',
    date: '2025-09-17 19:22',
    location: '湖北',
    img: require('@/assets/image/news/10-17.jpg'),
    content: [
      { type: 'text', content: '在2025中国文化旅游产业博览会上，华视集团与四十余家单位正式达成华视闪宝战略合作，各方将共同推进AI数字人项目的落地应用。此次大规模合作标志着华视闪宝在文旅数字化解决方案方面获得了行业广泛认可，进一步巩固了市场领先地位。' },
      { type: 'image', content: require('@/assets/image/news/9-17-1.jpg'), alt: '考察现场' },
      { type: 'text', content: '本次签约单位覆盖多地文旅主管部门、知名文化机构与领先科技企业，包括山西、宁夏、西安、武汉、黄石、黄冈、宜昌、恩施州、神农架、大冶、新洲、蔡甸、武昌等省市区级文旅单位，以及故宫博物院、湖北省博物馆、赤都文化等重要文化场馆，同时还包括中国电信、腾讯、极目智能、麦田智能、华沂科技、中奕天成、珈桥科技等科技伙伴。多方强强联合，旨在打通“技术—场景—应用”全链条，构建可复制、可推广的智慧文旅新生态。' },
      { type: 'image', content: require('@/assets/image/news/9-17-2.jpg'), alt: '考察现场' },
      { type: 'text', content: '华视闪宝作为AI数字人交互领域的创新代表，将持续为合作单位提供包括数字人IP定制、AIGC视频生成系统、数字人交互系统、屏形机器人、AI随身秘书等在内的多形态AI产品与解决方案，助力提升公众服务体验，丰富文旅互动形式。各方将共同推动项目落地、技术协同与运营创新，推动人工智能技术在文旅场景的规模化应用与高质量发展。' },
      { type: 'text', content: '此次战略合作不仅深化了华视闪宝与全国多地文旅资源的对接，也为中国文旅产业的智能化升级注入了新动能，展现出AI技术与文旅融合的广阔前景。' },
    ]
  },
]

export default {
  name: 'NewsDetail',
  data() {
    return {
      newsList: allNewsList,
      currentId: null
    }
  },
  computed: {
    currentNews() {
      if (this.newsList && this.newsList.length > 0 && this.currentId) {
        console.log("this.newsList.find(item => item.id === this.currentId)", this.currentId,this.newsList.find(item => item.id === this.currentId));
        
        return this.newsList.find(item => item.id === this.currentId)
      }
      return null
    },
    contentList() {
      if (!this.currentNews || !this.currentNews.content) {
        return []
      }
      return this.currentNews.content
    },
    currentNewsIndex() {
      return this.newsList.findIndex(item => item.id === this.currentNews?.id)
    },
    hasPrev() {
      return this.currentNewsIndex > 0
    },
    hasNext() {
      return this.currentNewsIndex < this.newsList.length - 1
    },
    prevNews() {
      if (!this.hasPrev) return null
      return this.newsList[this.currentNewsIndex - 1]
    },
    nextNews() {
      if (!this.hasNext) return null
      return this.newsList[this.currentNewsIndex + 1]
    }
  },
  mounted() {
    // 进入关于页面时滚动到顶部
    this.scrollToTop()
  },
  created() {
    // 从路由获取新闻ID
    const newsId = this.$route.params.id || this.$route.query.id
    if (newsId) {
      console.log("newsId", newsId);
      
      this.currentId = parseInt(newsId)
    } else if (this.newsList && this.newsList.length > 0) {
      // 默认显示第一条新闻
      this.currentId = this.newsList[0].id
    }
  },
  methods: {
    scrollToTop() {
      window.scrollTo({ top: 0, behavior: 'smooth' })
    },
    goBack() {
      this.$router.back()
    },
    goToPrev() {
      if (!this.hasPrev) return
      const prevIndex = this.currentNewsIndex - 1
      this.currentId = this.newsList[prevIndex].id
      this.scrollToTop()
    },
    goToNext() {
      if (!this.hasNext) return
      const nextIndex = this.currentNewsIndex + 1
      this.currentId = this.newsList[nextIndex].id
      this.scrollToTop()
    },
    scrollToTop() {
      window.scrollTo({ top: 0, behavior: 'smooth' })
    }
  }
}
</script>

<style scoped>
.news-detail {
  min-height: 100vh;
  background-color: #f8f9fa;
  padding: 20px 0;
}

/* 返回按钮 */
.back-button-container {
  max-width: 800px;
  margin: 0 auto 30px;
  padding: 0 20px;
}

.back-btn {
  display: flex;
  align-items: center;
  gap: 8px;
  background: white;
  border: 1px solid #ddd;
  padding: 10px 20px;
  cursor: pointer;
  font-size: 1rem;
  color: #333;
  transition: all 0.3s ease;
}

.back-btn:hover {
  background: #f0f0f0;
  transform: translateX(-2px);
}

.back-btn .arrow {
  font-size: 1.2rem;
}

/* 新闻详情内容 */
.news-detail-content {
  max-width: 800px;
  margin: 0 auto;
  padding: 0 20px;
}

.news-detail-title {
  font-size: 2.5rem;
  color: #2c3e50;
  margin-bottom: 20px;
  line-height: 1.3;
  font-weight: 700;
}

.news-detail-date {
  color: #7f8c8d;
  font-size: 1rem;
  margin-bottom: 40px;
  padding-bottom: 20px;
  border-bottom: 1px solid #ddd;
}

/* 内容列表 */
.content-list {
  margin-bottom: 60px;
}

.content-item {
  margin-bottom: 30px;
}


.content-num {
  font-size: 2.2rem;
  color: #000;
  margin-bottom: 20px;
  font-weight: 600;
}

.content-title {
  color: #000;
  font-size: 1.2rem;
  margin-bottom: 20px;
  font-weight: 600;
  position: relative;
  padding-left: 15px;
}

.content-title::before {
  content: '';
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
  width: 2px;
  background-color: #e74c3c;
}

.content-text {
  font-size: 1.1rem;
  line-height: 1.8;
  color: #333;
  margin-bottom: 20px;
}

.content-image {
  width: 100%;
  margin: 10px 0;
  text-align: center;
  display: flex;
  justify-content: center;
  flex-direction: column;
  div {
    font-size: 0.8rem;
    color: #7f8c8d;
  }
}

.content-image img {
  width: 100%;
  height: auto;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
}

.content-video {
  width: 100%;
  margin: 30px 0;
  text-align: center;
}

.content-video video {
  max-width: 100%;
  height: auto;
  border-radius: 8px;
}

/* 分页按钮 */
.pagination {
  gap: 50px;
  display: flex;
  justify-content: space-between;
  padding: 40px 0;
  border-top: 1px solid #ddd;
}

.pager-link {
  color: #045FB2;
  font-size: 1rem;
  cursor: pointer;
  display: inline-flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 6px;
}

.pager-link:hover {
  text-decoration: underline;
}
.pager-label {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  color: #7f8c8d;
}

.pager-label .el-icon-arrow-left,
.pager-label .el-icon-arrow-right {
  font-size: 14px;
}

.pager-title {
  color: #045FB2;
  line-height: 1.6;
}

.pager-title.empty {
  color: #bdc3c7;
}

.pager-link.disabled {
  color: #bdc3c7;
  cursor: not-allowed;
  text-decoration: none;
}

/* 无数据 */
.no-data {
  text-align: center;
  padding: 100px 20px;
  color: #7f8c8d;
}

/* 响应式设计 */
@media (max-width: 768px) {
  .news-detail-title {
    font-size: 1.8rem;
  }
  
  .content-title {
    font-size: 1.4rem;
  }
  
  .content-text {
    font-size: 1rem;
  }
  
  .pagination-btn {
    padding: 10px 16px;
    font-size: 0.9rem;
  }
}

@media (max-width: 480px) {
  .news-detail-title {
    font-size: 1.5rem;
  }
  
  .back-btn,
  .pagination-btn {
    font-size: 0.9rem;
    padding: 8px 12px;
  }
}
</style>

